import { defineComponent as _defineComponent } from 'vue'
import DurationSelector from "@/components/history/DurationSelector.vue";
import ReportHistoryList from "@/components/history/ReportHistoryList.vue";
import NavigationBar from "@/components/shared/NavigationBar.vue";
import Page from "@/components/shared/Page.vue";
import ScrollTopControl from "@/components/shared/ScrollTopControl.vue";
import { IReportHistory } from "@/domain/entities/report";
import { useUserStore } from "@/stores/userStore";
import { PROVIDE_KEY_SHOW_ERROR_MODAL, ShowErrorModal } from "@/types";
import dayjs from "dayjs";
import { inject, onMounted, ref } from "vue";


const __default__ = {
  name: "ReportHistory",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose: __expose }) {
  __expose();

const showErrorModal = inject(PROVIDE_KEY_SHOW_ERROR_MODAL) as ShowErrorModal;

const DEFAULT_FROM_DATE = dayjs().subtract(1, "month").format("YYYY-MM-DD");
const DEFAULT_TO_DATE = dayjs().format("YYYY-MM-DD");

const userStore = useUserStore();

const reportHistoryList = ref<InstanceType<typeof ReportHistoryList>>();

const fromDate = ref(DEFAULT_FROM_DATE);
const updateFromDate = (date: string) => {
  fromDate.value = date;
};

const toDate = ref(DEFAULT_TO_DATE);
const updateToDate = (date: string) => {
  fromDate.value = date;
};

const reportHistories = ref<IReportHistory[]>([]);
const getReportHistory = async (fromDate: string, toDate: string) => {
  const result = await userStore.getReportHistory(fromDate, toDate);
  if (!result.isSuccess) {
    const { errorMessage, errorTime, resultCode } = result;
    showErrorModal("신고내역 조회", errorMessage, resultCode, errorTime);
    return;
  }

  reportHistories.value = result.data ?? [];
};

const handleSelectFromDate = async (fromDate: string, toDate: string) => {
  updateFromDate(fromDate);
  await getReportHistory(fromDate, toDate);
};
const handleSelectToDate = async (fromDate: string, toDate: string) => {
  updateToDate(toDate);
  await getReportHistory(fromDate, toDate);
};

onMounted(() => {
  getReportHistory(fromDate.value, toDate.value);
});

const __returned__ = { showErrorModal, DEFAULT_FROM_DATE, DEFAULT_TO_DATE, userStore, reportHistoryList, fromDate, updateFromDate, toDate, updateToDate, reportHistories, getReportHistory, handleSelectFromDate, handleSelectToDate, DurationSelector, ReportHistoryList, NavigationBar, Page, ScrollTopControl }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})